<div class="referral-container">
  <div class="referral-scroll">
    <img class="referral-top-image" src="assets/profile/referral-banner.png" />
    <div class="referral-close" (click)="close()">
      <img src="assets/general/back-blue.svg" />
    </div>
    <div class="referral-title">دعوت دوستان</div>
    <div class="referral-description">
      با دعوت هر یک از دوستان خود به بنتو ۱ هفته اشتراک رایگان دریافت کنید
    </div>
    <div class="referral-title" style="top: 32px">دوستان دعوت شده</div>
    <div *ngIf="referralUsers.length === 0" class="referral-no-one">
      هنوز کسی را دعوت نکرده‌اید!
    </div>
    <div
      *ngIf="referralUsers.length !== 0 && referralUsers.length <= 7"
      class="referral-users-holder-7"
    >
      <div
        *ngFor="let user of referralUsers; let last = last"
        class="referral-user"
        (click)="userSelected(user)"
        [ngStyle]="{ 'padding-left': last ? '16px' : '0' }"
      >
        <img
          class="referral-user-img"
          *ngIf="user.avatarPath !== ''"
          src="{{ user.avatarPath }}"
          onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
        />
        <img
          class="referral-user-img"
          *ngIf="user.avatarPath === ''"
          src="assets/blog/avatar.svg"
        />
        <div *ngIf="user.username" class="referral-user-name">
          {{ user.username }}
        </div>
        <div *ngIf="!user.username" class="referral-user-name">
          {{ user.name }}
        </div>
      </div>
    </div>
    <div *ngIf="referralUsers.length > 7" class="referral-users-holder-more">
      <table>
        <tr>
          <td
            *ngFor="let user of referralUsers; let last = last; let i = index"
            style="
              position: relative;
              display: inline-block;
              vertical-align: top;
            "
          >
            <div
              *ngIf="i % 2 === 0"
              class="referral-user"
              (click)="userSelected(user)"
              [ngStyle]="{ 'padding-left': last ? '16px' : '0' }"
            >
              <img
                class="referral-user-img"
                *ngIf="user.avatarPath !== ''"
                src="{{ user.avatarPath }}"
                onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
              />
              <img
                class="referral-user-img"
                *ngIf="user.avatarPath === ''"
                src="assets/blog/avatar.svg"
              />
              <div *ngIf="user.username" class="referral-user-name">
                {{ user.username }}
              </div>
              <div *ngIf="!user.username" class="referral-user-name">
                {{ user.name }}
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td
            *ngFor="let user of referralUsers; let last = last; let i = index"
            style="
              position: relative;
              display: inline-block;
              vertical-align: top;
            "
          >
            <div
              *ngIf="i % 2 === 1"
              class="referral-user"
              (click)="userSelected(user)"
              [ngStyle]="{ 'padding-left': last ? '16px' : '0' }"
              style="margin-top: 16px"
            >
              <img
                class="referral-user-img"
                *ngIf="user.avatarPath !== ''"
                src="{{ user.avatarPath }}"
                onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
              />
              <img
                class="referral-user-img"
                *ngIf="user.avatarPath === ''"
                src="assets/blog/avatar.svg"
              />
              <div *ngIf="user.username" class="referral-user-name">
                {{ user.username }}
              </div>
              <div *ngIf="!user.username" class="referral-user-name">
                {{ user.name }}
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div
      [ngClass]="
        referralUsers.length > 7
          ? 'referral-fake1'
          : referralUsers.length !== 0
          ? 'referral-fake2'
          : 'referral-fake3'
      "
    ></div>
    <div class="referral-code-holder" (click)="copyReferralCode()">
      <div class="referral-code-middle-box">
        <img class="referral-code-copy" src="assets/profile/copy.svg" />
        <div class="referral-code">{{ referralCode }}</div>
      </div>
    </div>
    <div class="referral-code-share-holder" (click)="shareReferralCode()">
      اشتراک گذاری لینک دعوت
    </div>
  </div>
</div>
<div class="profile-page" id="profilePage10" *ngIf="showProfile">
  <app-blog-profile
    [id]="profileId"
    [username]="selectedUsername"
    style="width: 100%; height: 100%"
  ></app-blog-profile>
  <div class="blog-back-holder" (click)="closeProfile()">
    <img src="assets/general/back-blue.svg" />
  </div>
</div>
